import { observer } from 'mobx-react'
import { User } from 'models'
import React from 'react'
import { useParams } from 'react-router';
import { RoutingParams } from 'routes';

export const DetailsUsers = observer((): JSX.Element => {
  const params: RoutingParams = useParams<RoutingParams>();

  const [user, setUser] = React.useState<User>(null);

  React.useEffect(() => {
    User.get(Number(params.id)).then(async (u: User) => {
      await u.loadCourses();
      await u.loadPrograms();
      setUser(u);
    })
  }, [])

  return (
    <div>
      User
      {user?.getFullName}
      Programs
      <ul>
        {user?.programs?.map((p) => (
          <li key={p.id}>{p.title}</li>
        ))}
      </ul>
      Courses
      <ul>
        {user?.courses?.map((c) => (
          <li key={c.id}>{c.title}</li>
        ))}
      </ul>
    </div>
  );
});
